import * as React from 'react';
import Notifications from '../components/Notifications';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";

const VehicleConfigurations = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    if (permissions && !permissions.CanView) navigate("/error401");
    if (localStorage.getItem("userid") === null) navigate("/logout");
    const subTotals = [];
    React.useEffect(() => { 
        GetColumnDefs("VehicleConfigurations", setColumns, setErrorMessage); 
        GetPermissions(["ViewTruckConfiguration", "NewTruckConfiguration", "EditTruckConfiguration", "DeleteTruckConfiguration", "ReportTruckConfiguration"], setPermissions)
    }, [])

    return (
        <div>
        <Notifications errorMessage={errorMessage}/>
            {columns && permissions && <DataGrid dataSource='apiv7/vehicleconfigurations' columns={columns} permissions={permissions} keyField="vehicleConfigurationId" subTotals={subTotals} />}
        </div>       
    );

}

export default VehicleConfigurations;